export default __webpack_public_path__ + "static/media/uploader-caresensBt-1.9e53e9aa.png";